import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ViewContainerRef } from '@angular/core';
import { LayerService } from '../../../services/layer.service';
var DataTableAdditionalInformationComponent = /** @class */ (function () {
    function DataTableAdditionalInformationComponent(_vcr, changeDetectorRef, layerService, LoggingService) {
        this.changeDetectorRef = changeDetectorRef;
        this.layerService = layerService;
        this.LoggingService = LoggingService;
        this.geoSnapTableId = 161;
        this.loading = false;
        this.hasChildTableRecords = function (dataItem) {
            return dataItem.data.length > 0;
        };
    }
    Object.defineProperty(DataTableAdditionalInformationComponent.prototype, "feature", {
        get: function () {
            return this._feature;
        },
        set: function (newValue) {
            this._feature = newValue;
            this.refreshGridData();
        },
        enumerable: true,
        configurable: true
    });
    DataTableAdditionalInformationComponent.prototype.refreshGridData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var childTableData;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        this.changeDetectorRef.detectChanges();
                        return [4 /*yield*/, this.loadChildTableData()];
                    case 1:
                        childTableData = _a.sent();
                        this.gridDataResult = {
                            data: childTableData,
                            total: childTableData.length
                        };
                        this.loading = false;
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    DataTableAdditionalInformationComponent.prototype.loadChildTableData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, e_2, _b, e_3, _c, childTableFeaturePromises, _d, _e, childTable, childParentKeyColumnName, columnId, childTableFeaturePromise, allChildTableDataForFeature, childTableDictionaryArray, allChildTableDataForFeature_1, allChildTableDataForFeature_1_1, record, childTable, dataArrayArray, dataDictionaryArray, dataArrayArray_1, dataArrayArray_1_1, dataArray, dataDictionary, i;
            return tslib_1.__generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        childTableFeaturePromises = [];
                        try {
                            for (_d = tslib_1.__values(this.childTables), _e = _d.next(); !_e.done; _e = _d.next()) {
                                childTable = _e.value;
                                childParentKeyColumnName = void 0;
                                if (childTable.tableId === this.geoSnapTableId) {
                                    childParentKeyColumnName = 'objectid';
                                }
                                else {
                                    childParentKeyColumnName = childTable.childParentKeyColumnName.toLowerCase();
                                }
                                columnId = this.feature[childParentKeyColumnName];
                                childTableFeaturePromise = this.layerService.getLayerChildTable(this.layerId, childTable.tableId, "id name columns { name } data(filter: \"" + childParentKeyColumnName + " = " + columnId + "\", fieldNames: [\"*\"])");
                                childTableFeaturePromises.push(childTableFeaturePromise);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4 /*yield*/, Promise.all(childTableFeaturePromises)];
                    case 1:
                        allChildTableDataForFeature = _f.sent();
                        childTableDictionaryArray = new Array();
                        try {
                            for (allChildTableDataForFeature_1 = tslib_1.__values(allChildTableDataForFeature), allChildTableDataForFeature_1_1 = allChildTableDataForFeature_1.next(); !allChildTableDataForFeature_1_1.done; allChildTableDataForFeature_1_1 = allChildTableDataForFeature_1.next()) {
                                record = allChildTableDataForFeature_1_1.value;
                                childTable = {};
                                childTable.name = record[0].childTables[0].name;
                                childTable.columns = record[0].childTables[0].columns;
                                dataArrayArray = record[0].childTables[0].data.length > 0
                                    ? record[0].childTables[0].data
                                    : [];
                                dataDictionaryArray = [];
                                if (dataArrayArray.length > 0) {
                                    try {
                                        for (dataArrayArray_1 = tslib_1.__values(dataArrayArray), dataArrayArray_1_1 = dataArrayArray_1.next(); !dataArrayArray_1_1.done; dataArrayArray_1_1 = dataArrayArray_1.next()) {
                                            dataArray = dataArrayArray_1_1.value;
                                            dataDictionary = {};
                                            for (i = 0; i < childTable.columns.length; i++) {
                                                dataDictionary[childTable.columns[i].name] =
                                                    dataArray[i];
                                            }
                                            dataDictionaryArray.push(dataDictionary);
                                        }
                                    }
                                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                                    finally {
                                        try {
                                            if (dataArrayArray_1_1 && !dataArrayArray_1_1.done && (_c = dataArrayArray_1.return)) _c.call(dataArrayArray_1);
                                        }
                                        finally { if (e_3) throw e_3.error; }
                                    }
                                }
                                childTable.data = dataDictionaryArray;
                                childTableDictionaryArray.push(childTable);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (allChildTableDataForFeature_1_1 && !allChildTableDataForFeature_1_1.done && (_b = allChildTableDataForFeature_1.return)) _b.call(allChildTableDataForFeature_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [2 /*return*/, childTableDictionaryArray];
                }
            });
        });
    };
    return DataTableAdditionalInformationComponent;
}());
export { DataTableAdditionalInformationComponent };
